import { CanalInterface } from 'store/reducers/canais';
import {
  ContatoInterface,
  ContatoInterfaceV2,
  ContatoSelectInterface,
} from 'store/reducers/contatos';
import { EquipeInterface } from 'store/reducers/equipes';
import { TagInterface } from 'store/reducers/tags';
import { UsuarioInterface } from 'store/reducers/usuarios';

export function normalizeContato(
  contato: ContatoInterface | ContatoInterfaceV2 | ContatoSelectInterface,
): ContatoInterface {
  // ContatoInterface
  if ('nome' in contato && 'foto' in contato && 'equipePadrao' in contato) {
    return contato as ContatoInterface;
  }

  // ContatoInterfaceV2
  if ('name' in contato && 'fotoUrl' in contato && 'teamDefault' in contato) {
    const v2 = contato as ContatoInterfaceV2;
    return {
      id: v2.id,
      nome: v2.name,
      contato: v2.contact,
      foto: v2.fotoUrl,
      status: v2.status,
      tipoCanal: v2.tipoCanal,
      tipo: v2.type,
      tags: v2.tags.map(
        tag =>
          ({
            id: tag.id,
            nome: tag.name,
            cor: tag.color,
          } as TagInterface),
      ),
      equipePadrao: v2.teamDefault
        ? ({
            id: v2.teamDefault.id,
            nome: v2.teamDefault.name,
          } as unknown as EquipeInterface)
        : null,
      usuarioPadrao: v2.atendenteDefault
        ? ({
            id: v2.atendenteDefault.id,
            nome: v2.atendenteDefault.name,
          } as unknown as UsuarioInterface)
        : null,
      canal: v2.channel
        ? ({
            id: v2.channel.id,
            nome: v2.channel.name,
            tipo: v2.channel.type,
          } as unknown as CanalInterface)
        : null,
      observacao: v2.observation,
      blockedAt: v2.blockedAt,
    };
  }

  // ContatoSelectInterface
  const select = contato as ContatoSelectInterface;
  return {
    id: select.id,
    nome: select.name,
    contato: select.contact,
    foto: select.fotoUrl,
    status: select.status,
    tipoCanal: select.channelType,
    tipo: select.type,
    tags: [],
    equipePadrao: null,
    usuarioPadrao: null,
    canal: select.channel
      ? ({
          id: select.channel.id,
          nome: select.channel.name,
          tipo: select.channel.type,
        } as unknown as CanalInterface)
      : null,
    observacao: null,
    blockedAt: select.blockedAt,
  };
}
